import { createAlert } from '../../../../alert.js?vue3';
import commitReferencesQuery from '../graphql/queries/commit_references.query.graphql';
import containingBranchesQuery from '../graphql/queries/commit_containing_branches.query.graphql';
import containingTagsQuery from '../graphql/queries/commit_containing_tags.query.graphql';
import { BRANCHES, TAGS, FETCH_CONTAINING_REFS_EVENT, FETCH_COMMIT_REFERENCES_ERROR, BRANCHES_REF_TYPE, TAGS_REF_TYPE } from '../constants';
import RefsList from './refs_list.vue?vue3';
export default {
    name: 'CommitRefs',
    components: {
        RefsList
    },
    inject: [
        'fullPath',
        'commitSha'
    ],
    apollo: {
        project: {
            query: commitReferencesQuery,
            variables () {
                return this.queryVariables;
            },
            update ({ project }) {
                if (!project?.commitReferences) return;
                const { tippingTags, tippingBranches, containingBranches, containingTags } = project.commitReferences;
                this.tippingTags = tippingTags.names;
                this.tippingBranches = tippingBranches.names;
                this.hasContainingBranches = Boolean(containingBranches.names.length);
                this.hasContainingTags = Boolean(containingTags.names.length);
            },
            error () {
                createAlert({
                    message: this.$options.i18n.errorMessage,
                    captureError: true
                });
            }
        }
    },
    data () {
        return {
            project: undefined,
            containingTags: [],
            containingBranches: [],
            tippingTags: [],
            tippingBranches: [],
            hasContainingBranches: false,
            hasContainingTags: false
        };
    },
    computed: {
        hasBranches () {
            return this.tippingBranches.length || this.hasContainingBranches;
        },
        hasTags () {
            return this.tippingTags.length || this.hasContainingTags;
        },
        queryVariables () {
            return {
                fullPath: this.fullPath,
                commitSha: this.commitSha
            };
        },
        isLoading () {
            return this.$apollo.queries.project.loading;
        }
    },
    methods: {
        async fetchContainingRefs ({ query, namespace }) {
            try {
                const { data } = await this.$apollo.query({
                    query,
                    variables: this.queryVariables
                });
                this[namespace] = data.project.commitReferences[namespace].names;
                return data.project.commitReferences[namespace].names;
            } catch  {
                return createAlert({
                    message: this.$options.i18n.errorMessage,
                    captureError: true
                });
            }
        },
        fetchContainingBranches () {
            this.fetchContainingRefs({
                query: containingBranchesQuery,
                namespace: 'containingBranches'
            });
        },
        fetchContainingTags () {
            this.fetchContainingRefs({
                query: containingTagsQuery,
                namespace: 'containingTags'
            });
        }
    },
    i18n: {
        branches: BRANCHES,
        tags: TAGS,
        errorMessage: FETCH_COMMIT_REFERENCES_ERROR
    },
    FETCH_CONTAINING_REFS_EVENT,
    BRANCHES_REF_TYPE,
    TAGS_REF_TYPE
};
